

import type {
  BuildingId,
  ReputationUpgradeId,
  ReputationUpgradeDef,
} from "./types";

export const BUILDINGS: Record<BuildingId, { name: string; description: string }> = {
  forge: {
    name: "Кузница",
    description: "Улучшить карту до усиленной версии Надежды. Стоимость: золото.",
  },
  tavern: {
    name: "Таверна",
    description: "Купить карту своего домена за золото.",
  },
  guild: {
    name: "Гильдия авантюристов",
    description: "Вложить репутацию в постоянные бонусы.",
  },
  temple: {
    name: "Храм",
    description: "Сбросить накопленный Страх или получить временный бафф.",
  },
};

export const REPUTATION_UPGRADES: Record<ReputationUpgradeId, ReputationUpgradeDef> = {
  hunter_luck: {
    id: "hunter_luck",
    name: "Удача охотника",
    description: "+5% к шансу лута со всех мобов.",
    costs: [3, 3, 3], 
    effectPerLevel: "+5% шанс лута",
  },
  sharp_eye: {
    id: "sharp_eye",
    name: "Острый глаз",
    description: "+10% к шансу редкого лута.",
    costs: [5, 5], 
    effectPerLevel: "+10% редкого лута",
  },
  domain_knowledge: {
    id: "domain_knowledge",
    name: "Знание домена",
    description: "+1 карта домена в предложении Level Up.",
    costs: [4], 
    effectPerLevel: "+1 карта на Level Up",
  },
  trade_ties: {
    id: "trade_ties",
    name: "Торговые связи",
    description: "−10% к цене в Таверне и Кузнице.",
    costs: [4, 4],
    effectPerLevel: "−10% цены",
  },
};


export function nextReputationCost(upgrade: ReputationUpgradeDef, currentLevel: number): number | null {
  if (currentLevel >= upgrade.costs.length) return null;
  return upgrade.costs[currentLevel];
}


function tradeTiesDiscount(upgrades?: Partial<Record<ReputationUpgradeId, number>>): number {
  const lvl = upgrades?.trade_ties ?? 0;
  return Math.max(0, 1 - 0.1 * lvl);   
}


export function forgeUpgradeCost(
  rarity: "common" | "uncommon" | "rare" | "epic",
  upgrades?: Partial<Record<ReputationUpgradeId, number>>,
): number {
  const base = { common: 100, uncommon: 200, rare: 400, epic: 800 }[rarity];
  return Math.round(base * tradeTiesDiscount(upgrades));
}


export function tavernCardCost(
  rarity: "common" | "uncommon" | "rare" | "epic",
  upgrades?: Partial<Record<ReputationUpgradeId, number>>,
): number {
  const base = { common: 75, uncommon: 150, rare: 300, epic: 600 }[rarity];
  return Math.round(base * tradeTiesDiscount(upgrades));
}

export const TEMPLE_RESET_FEAR_COST = 50;    
export const TEMPLE_BUFF_COST = 200;         
export const TEMPLE_BUFF_DURATION_TURNS = 24;
